import { Tab, Tabs } from '@mui/material'

type AdministrationPageTabsProps = {
	currentTab: number
	tabLabels: string[]
	hideAttachmentsTab?: boolean
	onTabChanged: (event: React.SyntheticEvent, newValue: number) => void
}

export const AdministrationPageTabs = ({
	currentTab,
	tabLabels,
	hideAttachmentsTab = false,
	onTabChanged,
}: AdministrationPageTabsProps) => {
	return (
		<Tabs
			variant="scrollable"
			scrollButtons="auto"
			textColor="primary"
			indicatorColor="primary"
			value={currentTab}
			onChange={onTabChanged}
		>
			{tabLabels.map((label) => (
				<Tab label={label} key={label} hidden={label === 'Attachment Types' && hideAttachmentsTab} />
			))}
		</Tabs>
	)
}
